import { useState, useEffect } from 'react';
import { useJiraServiceManagementProjectNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { useSitePersonalization } from '@atlassian/jira-personalization-service/src/services/site/index.tsx';
import type { UseResourceCustomContext } from '@atlassian/jira-resource-with-custom-router-context/src/controllers/types.tsx';
import { useInviteTeamDialog } from '@atlassian/jira-servicedesk-invite-team-service/src/services/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { PROJECTS_WITH_CORE_ACTIONS_TRAIT_NAME } from '../common/constants.tsx';

// Accepts a custom context and setter for dialog state
export const useShouldRenderInviteTeamPromptSpotlight = (
	customContext?: UseResourceCustomContext,
) => {
	const [_, { setIsInviteTeamDialogOpen }] = useInviteTeamDialog();
	const { data } = useJiraServiceManagementProjectNavigation(customContext) || {};
	const { isAdminAgent, project } = data || {};
	const { id: projectId } = project || {};
	const [ifTraitExists, setIfTraitExists] = useState(false);
	const [loadInviteTeamResource, setLoadInviteTeamResource] = useState(false);

	const { cloudId } = useTenantContext();
	const { fetch } = useSitePersonalization();

	const onInviteTeamOnboardingCTAClick = () => {
		setLoadInviteTeamResource(true);
		// to open "Invite team" modal from the onboarding spotlight
		setIsInviteTeamDialogOpen(true);
	};

	useEffect(() => {
		const performFetch = async () => {
			const personalizationData = await fetch({ cloudId });
			personalizationData?.find((trait) => {
				if (
					typeof trait.value === 'string' &&
					trait.name === PROJECTS_WITH_CORE_ACTIONS_TRAIT_NAME
				) {
					setIfTraitExists(JSON.parse(trait.value).includes(projectId?.toString()));
				}
				return null;
			}) !== undefined;
		};
		performFetch();
	}, [cloudId, fetch, projectId, setIfTraitExists]);

	return {
		isInviteTeamSpotlightEnabled: isAdminAgent && ifTraitExists,
		loadInviteTeamResource,
		onInviteTeamOnboardingCTAClick,
	};
};
